import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollTopRoutes = [
  '/home',
  '/search',
  '/account',
  '/sell',
  '/orders',
  '/admin',
  '/products',
  '/sellers',
  '/about',
  '/developers',
  '/shipping-policy',
  '/payment-methods',
  '/privacy',
  '/terms',
  '/refunds',
];

const shouldScrollToTop = (pathname) => {
  const localizedPath = pathname === '/es' ? '/' : pathname.replace(/^\/es(?=\/)/, '');
  return localizedPath === '/'
    || scrollTopRoutes.some((route) => localizedPath === route || localizedPath.startsWith(`${route}/`));
};

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => {
      window.history.scrollRestoration = previous;
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const targetId = decodeURIComponent(location.hash.slice(1));
      const frame = window.requestAnimationFrame(() => {
        document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return () => window.cancelAnimationFrame(frame);
    }
    if (!shouldScrollToTop(location.pathname)) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.hash, location.key, location.pathname, location.search]);

  return null;
};

export { shouldScrollToTop };
export default ScrollToTop;
